<section class="overlay" role="status" aria-live="polite" aria-atomic="true">
  <div class="content">
    <img class="icon" src="assets/img/spore-sad-block.png" alt="" aria-hidden="true" />
    <p class="title">{{ title }}</p>
    <p class="description">{{ description }}</p>
  </div>
</section>
